var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"Tab",class:{ 'Tab--disabled' : _vm.disabled },attrs:{"to":!_vm.external ? _vm.target : _vm.to,"exactActiveClass":"Tab--active","event":!_vm.disabled ? 'click' : ''}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }